import React from 'react';

export function SvgSempione()  {
  return (
      <svg id="Sempione" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 842 236" >
          <g transform="translate(0.000000,236.000000) scale(0.100000,-0.100000)"
             fill="#FFFFFF" stroke="none">
              <path d="M270 1138 c0 -668 1 -702 18 -681 9 12 170 222 357 467 187 245 343
445 346 446 4 0 40 -45 80 -100 41 -54 77 -99 80 -100 3 0 115 145 249 323
134 177 247 328 253 335 7 9 -131 12 -687 12 l-696 0 0 -702z"/>
              <path d="M1226 1141 c-295 -385 -536 -702 -536 -705 0 -3 243 -6 540 -6 l540
0 0 705 c0 388 -2 705 -4 705 -2 0 -245 -315 -540 -699z"/>
              <path d="M3266 1463 c-32 -164 -60 -308 -63 -320 -5 -21 -2 -23 40 -23 54 0
47 -15 83 190 14 85 28 157 29 159 4 3 23 -37 115 -246 30 -68 56 -123 59
-123 4 0 42 82 86 181 44 100 83 183 86 185 4 2 19 -75 35 -171 l28 -175 49 0
c46 0 49 1 44 23 -3 12 -29 155 -57 317 -29 162 -53 296 -54 298 -2 1 -47 -96
-101 -215 -54 -120 -101 -224 -104 -231 -5 -8 -50 82 -111 217 -56 127 -104
231 -105 231 -1 0 -28 -134 -59 -297z"/>
              <path d="M5370 1443 l0 -323 50 0 50 0 0 207 0 207 147 -154 c81 -85 178 -186
215 -225 l68 -70 0 318 0 317 -45 0 -45 0 0 -207 0 -208 -63 65 c-34 36 -133
139 -220 230 l-157 165 0 -322z"/>
              <path d="M7462 1448 c-34 -173 -62 -318 -62 -322 0 -3 20 -6 44 -6 53 0 46
-16 81 190 15 85 28 157 30 159 4 4 17 -25 112 -241 31 -71 59 -128 62 -128 3
0 42 82 85 181 44 99 82 182 86 184 4 2 20 -74 36 -170 l28 -175 49 0 c41 0
48 3 43 18 -2 9 -28 153 -57 319 -29 167 -54 301 -56 299 -2 -2 -47 -100 -101
-218 -53 -118 -101 -215 -107 -217 -5 -2 -49 84 -97 190 -48 107 -93 207 -101
224 -13 28 -17 12 -75 -287z"/>
              <path d="M2385 1716 c-37 -16 -82 -68 -91 -102 -12 -45 3 -105 33 -136 15 -17
64 -47 108 -68 98 -46 118 -66 118 -122 0 -35 -6 -47 -33 -71 -28 -25 -39 -28
-72 -24 -48 6 -73 28 -89 74 -11 34 -12 34 -53 28 -22 -4 -43 -9 -44 -10 -10
-9 12 -68 38 -103 36 -50 83 -72 154 -72 125 0 209 96 191 216 -10 67 -53 109
-162 160 -73 34 -94 48 -99 68 -9 38 4 66 41 83 40 19 77 12 111 -22 24 -24
27 -24 54 -10 16 8 31 19 34 24 9 14 -44 72 -81 87 -41 18 -119 17 -158 0z"/>
              <path d="M4824 1709 c-70 -27 -128 -79 -161 -147 -38 -77 -40 -200 -5 -277 31
-68 83 -118 155 -150 53 -24 69 -27 146 -23 137 6 214 57 270 178 34 75 35
181 2 258 -32 70 -115 146 -183 167 -70 20 -162 18 -224 -6z m231 -92 c21 -12
53 -41 69 -65 39 -55 48 -157 21 -227 -20 -54 -83 -111 -139 -126 -171 -46
-319 103 -276 280 34 141 194 210 325 138z"/>
              <path d="M6795 1714 c-46 -24 -63 -43 -81 -90 -34 -91 13 -166 135 -214 97
-39 133 -82 117 -145 -25 -101 -172 -96 -193 6 -6 30 -7 31 -47 25 -22 -4 -42
-9 -44 -11 -12 -12 13 -80 40 -111 43 -48 77 -64 143 -64 120 0 195 71 195
186 0 92 -40 139 -160 189 -78 32 -102 54 -102 90 0 68 95 95 150 42 29 -28
29 -28 60 -10 37 21 38 26 12 63 -39 54 -160 78 -225 44z"/>
              <path d="M2760 1420 l0 -300 170 0 170 0 0 40 0 40 -120 0 -120 0 0 95 0 95
115 0 115 0 0 45 0 45 -115 0 -115 0 0 75 0 74 118 3 117 3 3 43 3 42 -170 0
-171 0 0 -300z"/>
              <path d="M3990 1420 l0 -300 45 0 45 0 0 119 0 118 60 6 c33 4 73 13 88 21 74
39 114 126 93 202 -27 98 -88 133 -233 134 l-98 0 0 -300z m211 197 c43 -27
48 -106 8 -143 -12 -10 -41 -19 -74 -22 l-55 -4 0 97 0 98 51 -7 c28 -4 59
-12 70 -19z"/>
              <path d="M4420 1420 l0 -300 45 0 45 0 0 300 0 300 -45 0 -45 0 0 -300z"/>
              <path d="M6050 1420 l0 -300 165 0 165 0 0 40 0 40 -120 0 -120 0 0 95 0 95
115 0 115 0 0 45 0 45 -115 0 -115 0 0 75 0 75 120 0 120 0 0 45 0 45 -165 0
-165 0 0 -300z"/>
              <path d="M7180 1420 l0 -300 45 0 45 0 0 300 0 300 -45 0 -45 0 0 -300z"/>
              <path d="M5557 803 c-4 -3 -7 -46 -7 -94 l0 -88 -27 15 c-36 18 -57 18 -93 -1
-38 -20 -50 -43 -50 -100 0 -57 12 -80 50 -100 36 -19 57 -19 93 -1 15 8 27
11 27 5 0 -5 9 -9 20 -9 19 0 20 7 20 190 0 152 -3 190 -13 190 -8 0 -17 -3
-20 -7z m-25 -210 c23 -21 24 -89 1 -115 -20 -22 -76 -24 -96 -3 -33 32 -29
103 7 127 20 13 69 8 88 -9z"/>
              <path d="M5910 621 c0 -185 1 -191 20 -191 20 0 20 5 18 187 -3 170 -5 188
-20 191 -17 3 -18 -11 -18 -187z"/>
              <path d="M2355 761 c-48 -22 -69 -44 -90 -94 -21 -51 -19 -95 8 -147 62 -124
234 -130 295 -10 12 24 22 55 22 67 0 22 -4 23 -70 23 -56 0 -70 -3 -70 -15 0
-11 12 -15 50 -15 54 0 58 -5 35 -50 -43 -83 -180 -77 -227 11 -52 98 14 209
125 209 37 0 53 -6 80 -29 23 -21 37 -27 48 -21 21 14 1 41 -51 68 -53 27
-101 28 -155 3z"/>
              <path d="M6195 769 c-33 -19 -45 -41 -45 -79 0 -43 15 -59 91 -98 47 -24 54
-31 57 -60 4 -44 -21 -72 -63 -72 -31 0 -65 25 -65 48 0 14 -26 16 -35 3 -11
-18 18 -60 52 -76 75 -36 153 9 153 88 0 51 -18 71 -96 110 -59 30 -71 50 -49
83 18 28 65 32 90 8 15 -16 45 -13 45 4 0 34 -96 63 -135 41z"/>
              <path d="M3990 600 l0 -170 71 0 c65 0 73 2 100 29 41 42 41 99 -1 134 -25 22
-27 27 -15 37 25 20 19 87 -10 115 -20 21 -34 25 -85 25 l-60 0 0 -170z m108
124 c45 -31 17 -104 -40 -104 -28 0 -28 1 -28 60 0 56 2 60 23 60 12 0 33 -7
45 -16z m39 -157 c19 -19 20 -64 2 -83 -8 -7 -36 -17 -62 -20 l-47 -7 0 68 0
68 46 -6 c25 -2 53 -12 61 -20z"/>
              <path d="M7274 736 c-8 -21 3 -36 27 -36 15 0 20 6 17 22 -4 27 -35 37 -44 14z"/>
              <path d="M2712 641 c-7 -4 -24 -6 -38 -3 l-24 4 0 -106 c0 -99 1 -106 20 -106
18 0 20 7 20 78 0 83 9 102 46 102 21 0 39 22 27 34 -9 9 -36 7 -51 -3z"/>
              <path d="M3108 635 c-16 -9 -28 -11 -28 -5 0 5 -7 10 -15 10 -13 0 -15 -25
-15 -165 0 -140 2 -165 15 -165 12 0 15 14 15 70 l0 71 31 -17 c40 -20 88 -12
120 22 35 38 35 123 -2 159 -31 32 -85 40 -121 20z m96 -47 c38 -53 9 -128
-49 -128 -69 0 -100 84 -49 134 24 24 80 20 98 -6z"/>
              <path d="M3381 634 c-17 -13 -26 -14 -29 -6 -2 7 -10 12 -18 12 -11 0 -14 -29
-14 -165 0 -140 2 -165 15 -165 12 0 15 14 15 70 0 39 2 70 5 70 3 0 17 -7 30
-16 61 -40 145 19 145 102 0 82 -89 141 -149 98z m91 -41 c23 -21 24 -89 1
-115 -25 -28 -77 -24 -102 8 -12 15 -21 37 -21 49 0 12 9 34 21 49 24 31 72
35 101 9z"/>
              <path d="M3644 640 c-65 -26 -85 -123 -38 -179 66 -79 194 -31 194 73 0 83
-79 137 -156 106z m98 -47 c23 -21 24 -89 1 -115 -23 -25 -84 -24 -108 2 -11
12 -19 36 -19 55 0 46 28 75 72 75 20 0 44 -7 54 -17z"/>
              <path d="M4305 641 c-41 -17 -60 -50 -60 -106 0 -43 5 -59 24 -79 32 -34 80
-42 120 -22 17 9 31 12 31 6 0 -5 9 -10 20 -10 19 0 20 7 20 105 0 98 -1 105
-20 105 -11 0 -20 -5 -20 -10 0 -6 -13 -4 -30 5 -32 16 -55 18 -85 6z m95 -51
c12 -12 20 -33 20 -55 0 -46 -29 -75 -74 -75 -41 0 -66 28 -66 75 0 17 7 41
16 53 20 29 76 30 104 2z"/>
              <path d="M4590 640 c-8 -5 -25 -7 -37 -3 -23 5 -23 4 -23 -101 0 -88 3 -106
15 -106 12 0 15 14 15 63 0 78 16 111 54 115 39 5 46 -10 46 -100 0 -71 2 -78
20 -78 18 0 20 7 20 85 0 78 -2 88 -25 110 -25 26 -59 32 -85 15z"/>
              <path d="M4813 630 c-40 -24 -53 -48 -53 -99 0 -77 79 -130 150 -101 18 8 30
20 30 31 0 20 -15 26 -25 9 -3 -5 -23 -10 -44 -10 -47 0 -75 28 -75 75 0 47
28 75 75 75 21 0 41 -4 44 -10 10 -16 25 -11 25 8 0 20 -38 42 -73 42 -12 0
-36 -9 -54 -20z"/>
              <path d="M5043 640 c-73 -30 -79 -158 -9 -201 37 -23 62 -24 99 -5 15 8 27 11
27 5 0 -5 9 -9 20 -9 19 0 20 7 20 105 0 98 -1 105 -20 105 -11 0 -20 -4 -20
-9 0 -6 -12 -3 -27 5 -31 16 -58 17 -90 4z m101 -52 c37 -52 9 -128 -47 -128
-38 0 -50 7 -66 37 -29 55 4 113 64 113 24 0 39 -7 49 -22z"/>
              <path d="M5701 636 c-49 -27 -66 -107 -36 -166 29 -55 120 -63 166 -14 20 21
21 27 9 34 -10 6 -21 3 -35 -10 -40 -37 -115 -15 -115 33 0 15 12 17 80 17 73
0 80 2 80 20 0 74 -83 122 -149 86z m93 -42 c27 -27 18 -34 -44 -34 -33 0 -60
3 -60 7 0 3 7 15 17 25 20 22 66 24 87 2z"/>
              <path d="M6453 640 c-38 -15 -65 -69 -60 -118 8 -76 69 -116 142 -92 40 13 65
48 44 61 -9 5 -20 1 -32 -12 -25 -27 -81 -26 -101 3 -30 43 -22 48 70 48 l86
0 -7 28 c-18 75 -76 108 -142 82z m95 -57 l14 -23 -66 0 c-69 0 -71 2 -43 38
16 21 77 11 95 -15z"/>
              <path d="M6712 641 c-7 -4 -24 -6 -38 -3 l-24 4 0 -106 c0 -99 1 -106 20 -106
18 0 20 7 20 71 0 82 11 109 45 109 34 0 45 -27 45 -109 0 -56 3 -71 15 -71
12 0 15 14 15 64 0 88 12 116 49 116 36 0 41 -12 41 -106 0 -67 2 -74 20 -74
18 0 20 7 20 78 0 88 -14 123 -54 137 -21 7 -34 6 -58 -8 -27 -15 -32 -15 -51
-2 -24 17 -45 19 -65 6z"/>
              <path d="M7073 635 c-13 -9 -23 -11 -23 -6 0 6 -9 11 -20 11 -19 0 -20 -7 -20
-165 0 -158 1 -165 20 -165 18 0 20 7 20 69 l0 70 28 -15 c34 -18 56 -18 91 0
33 18 51 54 51 106 0 77 -91 135 -147 95z m89 -42 c23 -21 24 -89 1 -115 -9
-10 -30 -18 -49 -18 -65 0 -94 80 -47 132 20 23 70 23 95 1z"/>
              <path d="M7445 641 c-43 -19 -68 -59 -68 -107 0 -38 5 -51 32 -77 26 -26 39
-32 75 -32 30 0 54 7 73 21 54 40 55 136 3 176 -30 22 -87 31 -115 19z m99
-53 c39 -56 6 -128 -58 -128 -39 0 -76 37 -76 75 0 12 9 34 21 49 27 35 90 37
113 4z"/>
              <path d="M7722 641 c-7 -4 -24 -6 -38 -3 l-24 4 0 -106 c0 -99 1 -106 20 -106
18 0 20 7 20 79 0 87 10 105 57 99 l28 -3 3 -87 c3 -80 5 -88 22 -88 18 0 20
7 20 89 0 85 -1 91 -26 110 -28 22 -60 27 -82 12z"/>
              <path d="M7954 640 c-86 -34 -85 -182 1 -210 45 -15 86 -6 116 26 20 21 21 27
9 34 -10 6 -21 3 -35 -10 -40 -37 -115 -15 -115 33 0 15 12 17 80 17 72 0 80
2 80 19 0 72 -70 118 -136 91z m80 -46 c27 -27 18 -34 -44 -34 -33 0 -60 3
-60 7 0 3 7 15 17 25 20 22 66 24 87 2z"/>
              <path d="M2802 555 c5 -103 23 -130 87 -130 67 0 81 22 81 127 0 72 -3 88 -15
88 -12 0 -15 -15 -15 -71 0 -85 -11 -109 -48 -109 -44 0 -52 16 -52 102 0 73
-1 78 -21 78 -21 0 -21 -4 -17 -85z"/>
              <path d="M7280 535 c0 -98 1 -105 20 -105 19 0 20 7 20 105 0 98 -1 105 -20
105 -19 0 -20 -7 -20 -105z"/>
          </g>
      </svg>

  );
};

